@if (report(); as data) {
  <div class="import-report" role="status" data-cy="import-report">
    <div class="import-report__bar">
      <span class="import-report__title">{{ data.title }}</span>

      @for (stat of data.stats; track stat.label) {
        <span class="import-report__stat {{ statModifier(stat) }}">
          <i class="pi {{ statIcon(stat) }}"></i>
          {{ stat.label }}: {{ stat.value }}

          @if (stat.navigable && hasEntries(stat.type)) {
            <button
              type="button"
              class="import-report__nav"
              [attr.aria-label]="'Previous — ' + stat.label"
              (click)="scrollToEntry(stat.type, -1)"
            >
              <i class="pi pi-chevron-up"></i>
            </button>
            <button
              type="button"
              class="import-report__nav"
              [attr.aria-label]="'Next — ' + stat.label"
              (click)="scrollToEntry(stat.type, 1)"
            >
              <i class="pi pi-chevron-down"></i>
            </button>
          }
        </span>
      }

      <button
        type="button"
        class="import-report__close"
        aria-label="Close report"
        data-cy="import-report-close"
        (click)="closed.emit()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    @if (data.entries.length) {
      <ul class="import-report__list">
        @for (entry of data.entries; track $index) {
          <li
            #entryItem
            class="import-report__entry import-report__entry--{{ entry.type }}"
            [class.import-report__entry--active]="activeEntry() === $index"
          >
            <i class="pi {{ entryIcon(entry.type) }}"></i>
            <span>{{ entry.text }}</span>
          </li>
        }
      </ul>
    } @else {
      <p class="import-report__empty">{{ data.emptyMessage }}</p>
    }
  </div>
}
